import { Menu } from 'lucide-react';

/**
 * Slim top bar shown only on phones (< md).
 * Provides a hamburger toggle for the off-canvas sidebar and mirrors the
 * PROP VEIW branding so users know what app they're in when the sidebar
 * is hidden.
 */
export default function MobileHeader({ onOpenSidebar }) {
  return (
    <header
      className="md:hidden sticky top-0 z-30 flex items-center gap-3 bg-slate-800 text-white border-b border-slate-700 px-4 py-3"
      data-testid="mobile-header"
    >
      <button
        type="button"
        onClick={onOpenSidebar}
        aria-label="Open navigation"
        data-testid="mobile-menu-toggle"
        className="p-1.5 rounded hover:bg-slate-700 transition-colors"
      >
        <Menu className="h-5 w-5" />
      </button>
      <img
        src="/logo.png"
        alt="PROP VEIW"
        className="w-8 h-8 object-contain rounded bg-white/95 p-0.5 ring-1 ring-amber-300/40"
      />
      <span className="font-manrope font-bold text-base tracking-tight">
        PROP VEIW
      </span>
    </header>
  );
}
